<template>

  <v-container  >
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="6" class="pt-6 pb-6">
            <span class="headline font-weight-light">
                    Popis SUMIT koordinatora
                    <v-icon slot="divider" @click="getData()" style="padding-bottom: 2px;">mdi-refresh</v-icon>
                </span>

        <v-breadcrumbs :items="breadcrumbs" style="padding-left: 0; padding-bottom: 0;">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>


      </v-col>

    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="6">
        <v-text-field
            outlined

            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="$checkPermission('educational_fields index')">
        <v-autocomplete
            outlined
            :items="cantons.items"
            item-text="title"
            item-value="id"
            hide-details
            label="Odaberi županiju.."
            v-model="select_canton"
            dense
            @change="getData()"
        ></v-autocomplete>
      </v-col>

      <!--    :options.sync="options"-->
      <!--    :server-items-length="serverItemsLength"-->
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="items.data"
            :loading="loading"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>

          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import ApiV2 from "@/services/ApiV2";
import {serverBus} from "@/main";

export default {
  name: "SUMITCoordinatorView",

  created: function () {
    if(localStorage.getItem('sumit-search')){
      this.search = localStorage.getItem('sumit-search')
    }
    if(localStorage.getItem('sumit-canton')){
      this.select_canton = parseInt(localStorage.getItem('sumit-canton'))
    }
    this.getCantons();
    this.getData();
    serverBus.$on('reload-all-data', () => {
      this.search = ''
      this.getData();
    })
  },
  watch:{
    search:{
      handler(){
        localStorage.setItem('sumit-search',this.search);
      },
      deep: true
    },
    select_canton:{
      handler(){
        localStorage.setItem('sumit-canton',this.select_canton);
      },
      deep: true
    }
  },
  methods: {
    getData() {
      ApiV2.get('get_coordinators', {

        params: {
          role_id: 3,
          canton_id: this.$checkPermission('educational_fields index')? this.select_canton : '',
          perPage: -1
        }
      })
          .then((response) => {
            this.items = response.data;

          }).catch(() => {
        serverBus.$emit('perform-layout-loading', false);

        serverBus.$emit('show-snackbar', false, 'Problem sa popisom županijskih koordinatora.')

      }).finally(() => {

        serverBus.$emit('perform-layout-loading', false);
      });
    },

    getCantons() {
      this.$axios.post('zupanija').then((response) => {
        this.cantons = response.data;
      })
    },

    performSearch: function () {
      let self = this;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = null;
      this.searchTimeout = setTimeout(function () {
        serverBus.$emit('perform-search', self.search);

        self.searchTimeout = null;
      }, 300);
    },

  },
  data: function () {
    return {
      items: [],
      cantons: [],
      loading: false,
      breadcrumbs: [{text: "Administracija"}, {text: "Izvještaji"}, {text: "Popis SUMIT koordinatora"}],
      searchTimeout: null,
      select_canton: 2,
      search: '',
      headers: [
        {
          text: 'Ime i prezime',
          value: 'user.full_name',
        },
        {text: 'eduID', value: 'user.aai_email'},
        {text: 'Telefon', value: 'user.phone'},
        {text: 'Škola', value: 'organisation.name'},
      ],
    }
  },
  beforeDestroy(){
    localStorage.removeItem('sumit-canton')
    localStorage.removeItem('sumit-search')
  }
}
</script>

<style scoped>

</style>